<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--home">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <br><br>
    <h1 id="main-title" class="vtz-h1" i18n>{{title}}</h1>
    @if(registrationOpen) {
      <p class="vtz-text vtz-text--center" i18n>
        Please enter your information exactly as it appears in your Voter Information Letter.
      </p>
      <h2 class="vtz-text vtz-text--center vtz-text--bold">
        <strong
          ><i i18n
          ><span class="vtz--red">*</span> indicates a required field.</i
          ></strong
          >
        </h2>
        <form
          (ngSubmit)="onSubmit()"
          [formGroup]="registrationForm"
          class="vtz-form"
        >
        @for (field of fields; track field; let i = $index) {
          @if (field.isMandatory) {
            <div class="vtz-form__row">
              @switch (field.fieldType) {
                <!--------------------------------LIST OF VALUES FIELD TYPE --------------------------------------->
                @case ('lov') {
                  <div class="vtz-form__item">
                    <label class="vtz-form__label" for="{{field.fieldName}}">
                      <span i18n="Form field label">{{ field.fieldTitle }}</span>
                      @if (field.isMandatory) {
                        <span class="vtz--red">*</span>
                      }
                      @if (field.fieldTooltip !== undefined) {
                        <button id="tooltip-{{field.fieldName}}"  class="vtz-tooltip"
                          matTooltip="{{field.fieldTooltip}}"
                          i18n-matTooltip="Tooltip information"
                          matTooltipPosition="after"
                          aria-label="Tooltip for input field"
                          i18n-aria-label="Explains to screen reader users what kind of element they are looking at"
                        (click)="onTooltipClick($event)"></button>
                      }
                    </label>
                    <select class="vtz-form__select" formControlName="{{field.fieldName}}" name="{{field.fieldName}}" id="{{field.fieldName}}" (blur)="onBlur(field.fieldName)">
                      <option value="null">Select</option>
                      @for (optionValue of pickerOptionsFor(field.fieldName); track optionValue; let i = $index) {
                        <option [value]="optionValue">{{optionValue}}</option>
                      }
                    </select>
                    @if(deliveryPristine){
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive"
                          i18n="Invalid form field">This field is required.
                        </span>
                      </div>
                    }
                  </div>
                }
                <!------------------------------- DATE PICKER FIELD TYPE ------------------------------------------>
                @case ('date') {
                  <div class="vtz-form__item">
                    <app-date-picker formControlName="{{field.fieldName}}" tooltipText="{{field.fieldTooltip}}" htmlIdPrefix="{{field.fieldName}}" [dateParts]="dateField?.dateParts ?? defaultDateParts"></app-date-picker>
                  </div>
                }
                <!------------------------------- PHONE FIELD TYPE ------------------------------------------------>
                @case (['phone','confirm_phone'].includes(field.fieldType) ? field.fieldType : '') {
                  <div class="vtz-form__item">
                    <label class="vtz-form__label" for="{{field.fieldName}}">
                      <span i18n="Form field label">{{ field.fieldTitle }}</span>
                      @if (field.isMandatory) {
                        <span class="vtz--red">*</span>
                      }
                      @if (field.fieldTooltip !== undefined) {
                        <button id="tooltip-{{field.fieldName}}"  class="vtz-tooltip"
                          matTooltip="{{field.fieldTooltip}}"
                          i18n-matTooltip="Tooltip information"
                          matTooltipPosition="after"
                          aria-label="Tooltip for input field"
                          i18n-aria-label="Explains to screen reader users what kind of element they are looking at"
                        (click)="onTooltipClick($event)"></button>
                      }
                    </label>
                    <ngx-intl-tel-input  id= "{{ field.fieldName }}"
                      [cssClass]="'vtz-form__input'"
                      [preferredCountries]="[country,'ca']"
                      [enableAutoCountrySelect]="true"
                      [enablePlaceholder]="false"
                      [searchCountryFlag]="true"
                      [searchCountryField]="[
                        SearchCountryField.Iso2,
                        SearchCountryField.Name
                      ]"
                      searchCountryPlaceholder="Search Country"
                      i18n-searchCountryPlaceholder="Enter the name of a country to search for|appears in a phone number entry field, as a placeholder in a typeahead widget for selecting the country code"
                      [selectFirstCountry]="false"
                      [selectedCountryISO]="(aboutService.aboutInformation | async)!.country"
                      [phoneValidation]="true"
                      name="phone"
                      inputId="{{ field.fieldName }}"
                      [separateDialCode]="true"
                      (paste)="disableCutPaste($event, field.fieldType)"
                      formControlName="{{ field.fieldName }}"
                [ngClass]="{ 'vtz-form__input--error':(registrationForm.controls[field.fieldName].touched &&
                  !registrationForm.controls[field.fieldName].valid) || (registrationForm.controls[field.fieldName].touched &&
                  registrationForm.controls[field.fieldName].errors?.required)}"
                      >
                    </ngx-intl-tel-input >
                    @if ( pastedPhone  &&  field.fieldType === 'confirm_phone')  {
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive"
                          i18n="Invalid form field">Pasting is not allowed in this field.
                        </span>
                      </div>
                    }

                    @if (
                      registrationForm.controls[field.fieldName].touched &&
                      registrationForm.controls[field.fieldName].errors?.required
                      ) {
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive"
                          i18n="Invalid form field">This field is required.
                        </span>
                      </div>
                    }
                    @if (
                      field.fieldType === 'phone' &&
                      registrationForm.controls[field.fieldName].touched &&
                      !registrationForm.controls[field.fieldName].errors?.required &&
                      !registrationForm.controls[field.fieldName].valid
                      ) {
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive"
                          i18n="Invalid form field">Please enter a valid mobile number.
                        </span>
                      </div>
                    }
                    @if (
                      field.fieldType === 'confirm_phone' &&
                      registrationForm.controls[field.fieldName].touched &&
                      !registrationForm.controls[field.fieldName].errors?.required &&
                      registrationForm.controls[field.fieldName].errors?.notMatch
                      ) {
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive"
                          i18n="Invalid form field">The phone numbers do not match.</span>
                      </div>
                    }
                    @if (
                      field.fieldType === 'confirm_phone' && mobilePasteNotAllowed
                      ) {
                      <div role="alert">
                        <span class="vtz-form__error" aria-live="assertive"
                          i18n="Invalid form field">Pasting is not allowed in this field.</span>
                      </div>
                    }
                  </div>
                }
                <!------------------------------- DEFAULT FIELD TYPE ---------------------------------------------->
                @default {
                  <div class="vtz-form__item">
                    <label class="vtz-form__label" for="{{field.fieldName}}">
                      <span i18n="Form field label">{{ field.fieldTitle }}</span>
                      @if (field.isMandatory) {
                        <span class="vtz--red">*</span>
                      }
                      @if (field.fieldTooltip !== undefined) {
                        <button id="tooltip-{{field.fieldName}}"  class="vtz-tooltip"
                          matTooltip="{{field.fieldTooltip}}"
                          i18n-matTooltip="Tooltip information"
                          matTooltipPosition="after"
                          aria-label="Tooltip for input field"
                          i18n-aria-label="Explains to screen reader users what kind of element they are looking at"
                        (click)="onTooltipClick($event)"></button>
                      }
                    </label>
                    <input class="vtz-form__input"
                      type="text"
                      id="{{ field.fieldName }}"
                      autocomplete="off"
                      formControlName="{{ field.fieldName }}"
                      name="{{ field.fieldName }}"
                      (paste)="handlePaste($event)"
                  [ngClass]="{ 'vtz-form__input--error': registrationForm.controls[field.fieldName].dirty &&
                  registrationForm.controls[field.fieldName].invalid}"
                      />
                      @if (
                        registrationForm.controls[field.fieldName].touched &&
                        registrationForm.controls[field.fieldName].errors?.required &&
                        field.isMandatory) {
                        <div role="alert">
                          <span class="vtz-form__error" aria-live="assertive"
                            i18n="Invalid form field">This field is required.
                          </span>
                        </div>
                      }
                      @if (
                        field.isRegistrationKey &&
                        registrationForm.controls[field.fieldName].dirty &&
                        registrationForm.controls[field.fieldName].errors?.maxlength) {
                        <div role="alert">
                          <span class="vtz-form__error" aria-live="assertive"
                            i18n="Invalid form field">Maximum {{maxRegistrationPinLength}} characters.
                          </span>
                        </div>
                      }
                      @if (
                        field.isRegistrationKey &&
                        registrationForm.controls[field.fieldName].dirty &&
                        registrationForm.controls[field.fieldName].errors?.pattern) {
                        <div role="alert">
                          <span class="vtz-form__error" aria-live="assertive"
                            i18n="Invalid form field">Please enter a valid {{field.fieldTitle}}: only letters and numbers.
                          </span>
                        </div>
                      }
                      @if (
                        registrationForm.controls[field.fieldName].touched &&
                        registrationForm.controls[field.fieldName].errors?.email) {
                        <div role="alert">
                          <span class="vtz-form__error" aria-live="assertive"
                            i18n="Invalid form field">Please enter a valid email address.
                          </span>
                        </div>
                      }
                      @if ( field.fieldType === 'email' &&
                        registrationForm.controls[field.fieldName].dirty &&
                        registrationForm.controls[field.fieldName].errors?.maxlength) {
                        <div role="alert">
                          <span class="vtz-form__error" aria-live="assertive"
                            id="email_too_long_error_message"
                            i18n="Invalid form field">Maximum {{maxEmailLength}} characters.
                          </span>
                        </div>
                      }
                      @if (field.fieldType === 'confirm_email' &&
                        registrationForm.controls[field.fieldName].touched &&
                        registrationForm.controls[field.fieldName].errors?.notMatch) {
                        <div role="alert">
                          <span class="vtz-form__error" aria-live="assertive"
                            i18n="Invalid form field">The emails do not match.
                          </span>
                        </div>
                      }
                      @if (field.fieldType === 'confirm_email' && pasteNotAllowed === true) {
                        <div role="alert">
                          <span class="vtz-form__error" aria-live="assertive"
                            i18n="Invalid form field">Pasting is not allowed in this field.
                          </span>
                        </div>
                      }
                    </div>
                  }
                }
              </div>
            }
          }
          @if(!aboutService.isVotingCenter()) {
            <ngx-invisible-recaptcha #captchaRef
              [siteKey]="recaptchaSiteKey"
              (success)="resolved($event)"
              aria-hidden="true">
            </ngx-invisible-recaptcha>
          }
          <div class="vtz-actions">
            <button class="button button-primary" id="registration-submit" type="submit"
              i18n="Button label" [disabled]="!registrationForm.valid || !registrationOpen">
              REGISTER
            </button>
          </div>
        </form>
        @if (displaySpinner) {
          <div class="progressSpinner" >
            <mat-spinner [diameter]="300" color="primary" ></mat-spinner>
            <div class="spinner-warning">
              <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
            </div>
          </div>
        }
      } @else if(aboutService.registrationNotYetOpen){
        <h1 id="main-title" class="vtz-h1" i18n>Registration not yet open</h1>
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>Registration will be open from {{aboutService.startTime}} to {{aboutService.endTime}}.</p>
      } @else {
        <h1 id="main-title" class="vtz-h1" i18n>Election Closed</h1>
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>The election was open from {{aboutService.startTime}} to {{aboutService.endTime}}.</p>
      }
      </div>
    </div>